<template>
  <div class="edit-box">
    <div class="frm-area">
      <div class="title">提款设置</div>
      <div class="frm-box">
        <van-form @submit="onSubmit">
          <van-collapse v-model="activeNames">
            <van-collapse-item title="银行卡" name="1">
              <div class="frm-item">
                <div class="frm-label">银行名称</div>
                <van-field
                  v-model="frm3.bank_name"
                  placeholder="请填写银行名称"
                />
              </div>
              <div class="frm-item">
                <div class="frm-label">持卡人姓名</div>
                <van-field v-model="frm3.address" placeholder="请填写姓名" />
              </div>
              <div class="frm-item">
                <div class="frm-label">银行卡号</div>
                <van-field
                  v-model="frm3.account"
                  placeholder="请填写银行卡号"
                />
              </div>
            </van-collapse-item>
            <van-collapse-item title="支付宝" name="2">
              <div class="frm-item">
                <div class="frm-label">支付宝账号</div>
                <van-field
                  v-model="frm1.account"
                  placeholder="请填写支付宝账号"
                />
              </div>
              <div class="frm-item">
                <div class="frm-label">支付宝二维码</div>
                <div style="padding: 16px 16px">
                  <van-uploader
                    v-model="fileList1"
                    multiple
                    :after-read="afterRead1"
                    :max-count="1"
                    :before-read="beforeRead"
                    :before-delete="file1Delete1"
                  >
                  </van-uploader>
                  <div
                    v-if="isUploadfront"
                    style="color: #ee0a24; font-size: 12px"
                  >
                    请上传支付宝二维码
                  </div>
                </div>
              </div>
            </van-collapse-item>
            <van-collapse-item title="微信" name="3">
              <div class="frm-item">
                <div class="frm-label">微信账号</div>
                <van-field
                  v-model="frm2.account"
                  placeholder="请填写微信账号"
                />
              </div>
              <div class="frm-item">
                <div class="frm-label">微信二维码</div>
                <div style="padding: 16px 16px">
                  <van-uploader
                    v-model="fileList2"
                    multiple
                    :after-read="afterRead2"
                    :max-count="1"
                    :before-read="beforeRead"
                    :before-delete="file1Delete2"
                  >
                  </van-uploader>
                  <div
                    v-if="isUploadback"
                    style="color: #ee0a24; font-size: 12px"
                  >
                    请上传微信二维码
                  </div>
                </div>
              </div>
            </van-collapse-item>
          </van-collapse>
          <div class="btn-box">
            <van-button
              native-type="submit"
              :loading="posting"
              loading-text="提交中..."
              style="background-color: #141423; color: #fff; border-radius: 8px"
              >保存</van-button
            >
          </div>
        </van-form>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'
import { getToken } from '@/utils/cookies'
export default {
  name: 'EditCardView',
  data () {
    return {
      activeNames: ['1'],
      frm3: {
        type: 3,
        account: null,
        bank_name: null,
        address: null
      },
      frm1: {
        type: 1,
        bank_name: '支付宝',
        account: null,
        qr: null
      },
      frm2: {
        type: 2,
        bank_name: '微信',
        account: null,
        qr: null
      },
      fileList1: [],
      fileList2: [],
      isUploadfront: false,
      isUploadback: false,
      posting: false
    }
  },
  mounted () {
    this.getWallet()
  },
  methods: {
    openMenu () {
      const that = this
      this.$nextTick(() => {
        that.$refs.mmv.showMenu = true
      })
    },
    beforeRead (file) {
      this.isUploadfront = false
      this.isUploadback = false
      const validTypes = [
        'image/jpeg',
        'image/png',
        'image/gif',
        'image/webp',
        'image/bmp',
        'image/svg+xml',
        'image/apng',
        'image/avif'
      ]
      if (!validTypes.includes(file.type)) {
        this.$toast.fail('请上传图片文件')
        return false
      }
      return true
    },
    async afterRead1 (file) {
      file.status = 'uploading'
      const formData = new FormData()
      formData.append('file', file.file)
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: 'bearer ' + getToken()
        }
      }
      await Axios.post('/api/index/tools.tools/upload', formData, config)
        .then(response => {
          if (response.data.code == 200) {
            file.status = ''
            this.frm1.qr = response.data.data.url
          } else {
            file.status = 'failed'
            this.$toast.fail(response.data.msg)
          }
        })
        .catch(error => {
          file.status = 'failed'
          console.log(error)
        })
    },
    file1Delete1 () {
      this.frm1.qr = null
      this.fileList1 = []
    },
    async afterRead2 (file) {
      file.status = 'uploading'
      const formData = new FormData()
      formData.append('file', file.file)
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: 'bearer ' + getToken()
        }
      }
      await Axios.post('/api/index/tools.tools/upload', formData, config)
        .then(response => {
          if (response.data.code == 200) {
            file.status = ''
            this.frm2.qr = response.data.data.url
          } else {
            file.status = 'failed'
            this.$toast.fail(response.data.msg)
          }
        })
        .catch(error => {
          file.status = 'failed'
          console.log(error)
        })
    },
    file1Delete2 () {
      this.frm2.qr = null
      this.fileList2 = []
    },
    async onSubmit () {
      if (this.posting) {
        return
      }
      this.posting = true
      const postdata = [this.frm1, this.frm2, this.frm3]

      await this.$http({
        method: 'post',
        url: 'bindUserBank',
        data: { list: postdata }
      })
        .then(res => {
          this.posting = false
          this.$toast.success(res.msg)
        })
        .catch(() => {
          this.posting = false
        })
    },
    async getWallet () {
      await this.$http({
        method: 'post',
        url: 'myWallet'
      })
        .then(res => {
          const data = res.data.list
          data.forEach(item => {
            if (item.type == 3) {
              this.frm3.account = item.account
              this.frm3.bank_name = item.bank_name
              this.frm3.address = item.address
            } else if (item.type == 2) {
              this.frm2.account = item.account
              this.frm2.qr = item.qr
              this.fileList2.push({url:item.qr})
            } else if (item.type == 1) {
              this.frm1.account = item.account
              this.frm1.qr = item.qr
              this.fileList1.push({url:item.qr})
            }
          })
        })
        .catch(() => {})
    }
  }
}
</script>
<style lang="scss" scoped>
.edit-box {
  margin: 40px 10px;
  padding: 15px 12px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 8px 8px 16px rgba(0, 0, 0, 0.3);
  .frm-area {
    .title {
      height: 38px;
      line-height: 38px;
      font-size: 18px;
      font-weight: 550;
      border-bottom: 1px solid #dcdee0;
    }
    .frm-box {
      margin: 8px 0;
      .frm-label {
        text-indent: 14px;
        font-size: 14px;
        margin-top: 10px;
      }
      .btn-box {
        margin: 16px 0 0;
        text-align: right;
      }
    }
  }
}
</style>
